<template>
  <div class="carousel-container" v-if="products">
    <div class="product-carousel" v-if="products.length">
      <carousel
          id="carousel"
          ref="carousel" 
          :loop="false" 
          :autoWidth="true"  
          :autoHeight="true"
          :touchDrag="false"
          :pullDrag="false"
          :freeDrag="false"
          :mouseDrag="false"
          :center="center"
          :nav="false"
          :dots="false"
          :items="maxAtPage" 
          :margin="margin"
      >
          <ProductCard
              v-for="(product, index) in products"
              :key="index"
              :product="product"
          />
          <template slot="prev"><span hidden ref="prev" class="prev">prev</span></template>
          <template slot="next"><span hidden  ref="next" class="next">next</span></template>
      </carousel>
    </div>
    <div class="product-carousel" style="height: 448px;" v-else></div>
    <PaginationComponent
        :showPagination="products.length > maxAtPage"
        :itemsCount="products.length"
        :currentPage="currentPage"
        :currentItem="currentItem"
        :maxAtPage="maxAtPage"
        :marketplace="marketplace"
        @changeItem="changeItem($event)"
        @changePage="changePage($event)"
    />
  </div>
</template>

<script>
import PaginationComponent from '@/components/pagination-component/PaginationComponent';
import ProductCard from '@/components/product-card/ProductCard';
import mixScreenDetect from '@/mixins/screen-resize.js'
import carousel from 'vue-owl-carousel';
import './product-carousel.sass'

export default {
  name: 'carousel-container',
  components: {
      carousel,
      PaginationComponent,
      ProductCard
  },
  props: {
    products: [],
    marketplace: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        currentPage: 1,
        currentItem: 1,
    }
  },
  mixins: [mixScreenDetect],
  computed: {
    margin() {
      if (this.device === 'mobile') return 14
      if (!document.getElementById('header-container')) return 24
      const width     = window.innerWidth
      const container = parseInt(window.getComputedStyle(document.getElementById('header-container'), null).getPropertyValue("width").replace("px", ''))
      const cardWidth = this.device === 'desktop'   ?   Math.min((width - 80 - 48) / 3, 448)  :   Math.min((width - 24) / 2, 438)
      const count     = Math.floor(container / cardWidth)

      const margin = (container - (cardWidth * count)) / Math.max((count - 1), 1)
      return Math.max(margin, 12)
    },
    center() {
      if (this.device === 'mobile' || this.device === 'tablet_m') return true
      return false
    },
    maxAtPage() {
      if (this.device === 'desktop') return 3
      if (this.device === 'tablet_m') return 1
      return 2
    }
  },
  methods: {
    changeItem(event) {
        this.currentItem = event.item
    },
    changePage(event) {
        this.currentPage = event.page
    },
    setDefault() {
        this.currentPage = 1
        this.currentItem = 1
    }
  },
  watch: {
    currentItem(newVal, oldVal) {
      if (newVal > oldVal) {
         this.$refs.next.click()
      } else {
        this.$refs.prev.click()
      }
    },
    products() {
      this.setDefault()
    },
  },
}
</script>